import React from 'react';

const IconTrash = ({ styleClass = "text-primary" }) => {
	return <i className={`fa-solid fa-trash-can ${styleClass} text-base`}></i>;
};
export default IconTrash;